module.exports = {"customer":"Kunde","supplier":"Lieferant","institution":"Institution","freelancer":"Freelancer"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/company/de.json
// module id = 1401
// module chunks = 1